"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leaderBoardView = void 0;
exports.leaderBoardView = {
    isEnable: false,
    totalRow: 50,
    isDirectDisplay: true,
    componentStyle: {
        backgroundColor: 'ffffff',
        top: '20%',
    },
    title: 'LEADERBOARD',
    titleStyle: {
        color: '000000',
        fontSize: '20px',
        textAlign: 'center',
    },
    description: '',
    descriptionStyle: {
        color: '000000',
        fontSize: '16px',
        textAlign: 'center',
    },
    pointText: 'points',
    pointTextStyle: {
        color: '000000',
        fontSize: '18px',
    },
};
